import { createContext, useContext } from 'react';

// Holds the PhoneFrame screen DOM node so overlays (bottom sheets) can portal
// into it — rendering over everything inside the phone, including the tab bar.
export const PhoneScreenContext = createContext<HTMLElement | null>(null);
export const usePhoneScreen = () => useContext(PhoneScreenContext);
